const CONTEXT = import.meta.env.VITE_CONTEXT || 'cl';

const withContext = (value) =>
  typeof value === 'string'
    ? value.replace(/\$\{VITE_CONTEXT\}/g, CONTEXT)
    : value;

const envRaw = {
  CONTEXT,
  CUSTOM_NODE_ENV: import.meta.env.VITE_CUSTOM_NODE_ENV,
  AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL,
  CLOUDERS_API_URL: import.meta.env.VITE_CLOUDERS_API_URL,
  ORDERS_API_URL: import.meta.env.VITE_ORDERS_API_URL,
  STORAGE_API_URL: import.meta.env.VITE_STORAGE_API_URL,
  ROUTES_API_URL: import.meta.env.VITE_ROUTES_API_URL,
  NEW_ROUTES_API_URL: import.meta.env.VITE_NEW_ROUTES_API_URL,
  DELIVERED_PICTURE_SAMPLE_URL: import.meta.env
    .VITE_DELIVERED_PICTURE_SAMPLE_URL,
  OPTIMIZE_ERROR_TTL: import.meta.env.VITE_OPTIMIZE_ERROR_TTL,
  PASSWORD_PLACEHOLDER: import.meta.env.VITE_PASSWORD_PLACEHOLDER,
  USER_FAQ_URL: import.meta.env.VITE_USER_FAQ_URL,
  FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env
    .VITE_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  FIREBASE_VAPID_KEY: import.meta.env.VITE_FIREBASE_VAPID_KEY,
  RATING_API: import.meta.env.VITE_RATING_API,
  RATING_INTERVAL: import.meta.env.VITE_RATING_INTERVAL,
  USER_API_URL: import.meta.env.VITE_USER_API_URL,
  INTERCOM_ID: import.meta.env.VITE_INTERCOM_ID,
  MAP_ROUTE_URL: import.meta.env.VITE_MAP_ROUTE_URL,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  HOW_TO_LEARN_PAYMENT_URL: import.meta.env.VITE_HOW_TO_LEARN_PAYMENT_URL,
  MAP_API_KEY: import.meta.env.VITE_MAP_API_KEY,
  LOGROCKET_ID: import.meta.env.VITE_LOGROCKET_ID,
  CLARITY_ID: import.meta.env.VITE_CLARITY_ID,
  NOTIFICATION_API_URL: import.meta.env.VITE_NOTIFICATION_API_URL,
  PUSH_PERMISSION_PROMPT_INTERVAL_MS:
    import.meta.env.VITE_PUSH_PERMISSION_PROMPT_INTERVAL_MS || 1800000,
  URL: import.meta.env.VITE_URL,
  PUSH_NOTIFICATION_HELPER_LINK: import.meta.env
    .VITE_PUSH_NOTIFICATION_HELPER_LINK,
  ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL,
  TERMS_AND_CONDITIONS_URL: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL,
  CLOUDERS_MANUAL_LINK: import.meta.env.VITE_CLOUDERS_MANUAL_LINK,
  ROUTE_SCHEDULE_LINK: import.meta.env.VITE_ROUTE_SCHEDULE_LINK,
  UPLOAD_TIMEOUT_MS: import.meta.env.VITE_UPLOAD_TIMEOUT_MS,
  TUTORIAL_LOCATION_URL: import.meta.env.VITE_TUTORIAL_LOCATION_URL,
  ONBOARDING_HELP_URL: import.meta.env.VITE_ONBOARDING_HELP_URL,
  ONBOARDING_APPROVAL_RATE_THRESHOLD: import.meta.env
    .VITE_ONBOARDING_APPROVAL_RATE_THRESHOLD,
  URL_GOV_BR_CNPJ_HOW_TO_CREATE: import.meta.env
    .VITE_URL_GOV_BR_CNPJ_HOW_TO_CREATE,
  MAX_ORDERS_NEW_CLOUDER: import.meta.env.VITE_MAX_ORDERS_NEW_CLOUDER
    ? Number(import.meta.env.VITE_MAX_ORDERS_NEW_CLOUDER)
    : 35,
};

const env = Object.fromEntries(
  Object.entries(envRaw).map(([key, value]) => [key, withContext(value)])
);

export default env;
